import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PulpHomogenizer = () => {
   const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322994132_Pulp_Homogenizer.png?alt=media&token=68687616-b135-484a-a9b6-b7f1da2d52be',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322994132_Pulp_Homogenizer.png?alt=media&token=68687616-b135-484a-a9b6-b7f1da2d52be'
    ];
    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Pulp Homogenizer</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Pulp Homogenizer</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                   For permanent stirring and homogenizing of disintegrated pulp samples. Equipment to homogenize a disintegrated pulp sample for a correct sheet forming. Before sheet forming with beaten and disintegrated pulp, the pulp shall have the same content of fibers for the first and also for the last sheet, which is made from one suspension probe. Therefore, the Equalizer stirs the suspension permanent so, that the pulp properties will not change significantly.
                                     <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Pulp Homogenizer"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default PulpHomogenizer